import { Dispatch } from "react";

class AdaptivePracticeActions {

    setAPSmartXpSession = (sessionData: {
        user_id: string, lo_id: string,
        classroom_id?: string, correct_count: number, isPractice: boolean,
    }) => {
        return (dispatch: Dispatch<any>) => {
            return new Promise<void>((resolve, reject) => {
                dispatch({
                    type: 'SET_AP_SMART_XP_SESSION',
                    payload: sessionData
                })
                resolve()
            });
        }
    }

    setAPLastAttempted = (data: {}) => {
        return (dispatch: Dispatch<any>) => {
            return new Promise<void>((resolve, reject) => {
                dispatch({
                    type: 'SET_AP_LAST_ATTEMPTED',
                    payload: data
                })
                resolve()
            });
        }
    }
    setAPDefaultLastAttempted = () => {
        return (dispatch: Dispatch<any>) => {
            return new Promise<void>((resolve, reject) => {
                dispatch({
                    type: 'SET_AP_DEFAULT_LAST_ATTEMPTED',
                    payload: {}
                })
                resolve()
            });
        }
    }

    setAPSessionLastAttempted = (data: {}) => {
        return (dispatch: Dispatch<any>) => {
            return new Promise<void>((resolve, reject) => {
                dispatch({
                    type: 'SET_AP_SESSION_LAST_ATTEMPTED',
                    payload: data
                })
                resolve()
            });
        }
    }
    
    setAPSessionDefaultLastAttempted = () => {
        return (dispatch: Dispatch<any>) => {
            return new Promise<void>((resolve, reject) => {
                dispatch({
                    type: 'SET_AP_SESSION_DEFAULT_LAST_ATTEMPTED',
                    payload: {}
                })
                resolve()
            });
        }
    }

    setIsChallengeResultSaved = (status: boolean) => {
        return (dispatch: Dispatch<any>) => {
            return new Promise<void>((resolve, reject) => {
                dispatch({
                    type: 'SET_AP_IS_CHALLENGE_RESULT_SAVED',
                    payload: status
                })
                resolve()
            });
        }
    }

    setChallengeResult = (data: {}) => {
        return (dispatch: Dispatch<any>) => {
            return new Promise<void>((resolve, reject) => {
                dispatch({
                    type: 'SET_AP_CHALLENGE_RESULT',
                    payload: data
                })
                resolve()
            });
        }
    }

}

export const adaptivePracticeActions = new AdaptivePracticeActions();